<template>
  <div>
    <Info />
    <ItemTable
      :visibleItems=visibleItems
      :invisibleItems=invisibleItems
      :col1=col1
      :col2=col2
      :col3=col3
      :isDisplayItem=isDisplayItem
      :isHideCol=false
      @setQuantity=setQuantity
      type="count"
    />
    <ShowHiddenItemBtn :isDisplayItem=isDisplayItem @clickShowHiddenItemBtn="clickShowHiddenItemBtn"></ShowHiddenItemBtn>
    <ButtonBar @back="back" @next="next"></ButtonBar>
    <ConfirmQuantity :isShowConfirmQuantity=isShowConfirmQuantity @confirm="confirm" @cancel="cancel"></ConfirmQuantity>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import ItemTableCol from '@/models/ItemTableCol';
  import ConfirmQuantity from '@/components/parts/ConfirmQuantity';

  export default {
    name: 'NormalTemperatureCount',
    components: {
      ConfirmQuantity,
    },
    created() {
      this.$parent.title = '';
      this.$parent.imageName = 'normalTemperatureCount';
      this.$parent.hasMaintenancne = true;
      this.$parent.showMaintenanceInformation = true;
    },
    computed: {
      ...mapGetters([
        'stockQuantities',
        'lossQuantities',
      ]),
      visibleItems() {
        return this.items.filter(item => item.lastDeliveryQuantity > 0);
      },
      invisibleItems() {
        return this.items.filter(item => item.lastDeliveryQuantity <= 0);
      },
    },
    data() {
      return {
        items: this.$store.getters.items(1),
        isDisplayItem: false,
        col1: new ItemTableCol(
          '前回納品後個数',
          'lastDelivery',
          this.$store.getters.lastDeliveryQuantities,
        ),
        col2: new ItemTableCol(
          '残数',
          'stock',
          this.$store.getters.stockQuantities,
          true
        ),
        col3: new ItemTableCol(
          'ロス',
          'loss',
          this.$store.getters.lossQuantities,
        ),
        isShowConfirmQuantity: false,
        backPageName: this.$store.getters.routes.normalTemperatureCount.back,
        nextPageName: this.$store.getters.routes.normalTemperatureCount.next,
      };
    },
    methods: {
      back() {
        this.$router.push({ name: this.backPageName });
      },
      next() {
        let error_messages = [];
        if (document.querySelectorAll('input.quantity.required-error').length > 0) {
          error_messages.push('記入漏れがあります');
        }

        Object.values(this.items).some((item) => {
          if (this.lossQuantities[item.itemId] > this.stockQuantities[item.itemId]) {
            error_messages.push('ロス数が残数を超えています');
            return true;
          }
        });

        if (error_messages.length > 0) {
          alert(error_messages.join('\r'));
          return false;
        }

        this.isShowConfirmQuantity = true;

        return true;
      },
      clickShowHiddenItemBtn() {
        this.isDisplayItem = !this.isDisplayItem;
      },
      setQuantity(type, itemId, quantity) {
        if (this[`${type}Quantities`][itemId] !== quantity) {
          this.$store.dispatch('setQuantity', { type, itemId, quantity });
        }

        if (this.lossQuantities[itemId] > this.stockQuantities[itemId]) {
          document.getElementById('loss' + itemId).classList.add('error');
        } else {
          document.getElementById('loss' + itemId).classList.remove('error');
        }
        return true;
      },
      confirm(quantity) {
        const sum = Object.values(this.items)
          .reduce((total, item) => total + (this.lossQuantities[item.itemId] || 0), 0);

        if (parseInt(quantity, 10) === sum) {
          this.$router.push({ name: this.nextPageName });
        } else {
          alert('ロス数が一致しません');
          return false;
        }
        this.isShowConfirmQuantity = false;
      },
      cancel() {
        this.isShowConfirmQuantity = false;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/NormalTemperatureCount.vue?39097a7a